var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content-preview" }, [
    _c("div", { staticClass: "navigation" }, [
      _c("div", { staticClass: "left" }, [
        _c("div", { staticClass: "back-button", on: { click: _vm.close } }, [
          _c("i", { staticClass: "material-icons" }, [_vm._v("arrow_back")]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "right" }, [
        _c(
          "div",
          {
            staticClass: "switch-wrapper",
            class: { active: _vm.knowledgeBaseClone.enabled },
          },
          [
            _c("div", {}, [
              _vm.knowledgeBaseClone.enabled
                ? _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.usedByAI"))),
                  ])
                : _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.notUsed"))),
                  ]),
            ]),
            _vm._v(" "),
            _c("a-switch", {
              attrs: {
                size: "small",
                checked: _vm.knowledgeBaseClone.enabled,
                disabled: _vm.busy,
              },
              on: { click: _vm.changeState },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "buttons" },
          [
            _c(
              "SupsisButton",
              {
                attrs: { small: "", ghost: "", disabled: _vm.busy },
                on: { click: _vm.deleteKnowledgeBase },
              },
              [_c("i", { staticClass: "material-icons" }, [_vm._v("delete")])]
            ),
            _vm._v(" "),
            _c(
              "SupsisButton",
              { attrs: { small: "", ghost: "", disabled: "" } },
              [_c("i", { staticClass: "material-icons" }, [_vm._v("refresh")])]
            ),
            _vm._v(" "),
            _c(
              "SupsisButton",
              {
                attrs: { small: "", ghost: "", disabled: _vm.busy },
                on: {
                  click: function ($event) {
                    _vm.editMode = !_vm.editMode
                  },
                },
              },
              [_c("i", { staticClass: "material-icons" }, [_vm._v("edit")])]
            ),
            _vm._v(" "),
            _c(
              "SupsisButton",
              {
                attrs: {
                  small: "",
                  primary: "",
                  disabled: !_vm.isChanged() || _vm.busy,
                },
                on: { click: _vm.updateArticle },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("message.saveAndClose")) +
                    "\n                "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "scroll-content" }, [
      !_vm.editMode
        ? _c("div", { staticClass: "doc-title" }, [
            _vm._v(_vm._s(_vm.knowledgeBase.article.title)),
          ])
        : _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.knowledgeBase.article.title,
                expression: "knowledgeBase.article.title",
              },
            ],
            staticClass: "doc-title title-input",
            attrs: { type: "text" },
            domProps: { value: _vm.knowledgeBase.article.title },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.knowledgeBase.article,
                  "title",
                  $event.target.value
                )
              },
            },
          }),
      _vm._v(" "),
      _c("div", { staticClass: "doc-content" }, [
        _c("div", { staticClass: "content-preview" }, [
          _c("i", { staticClass: "material-icons" }, [_vm._v("preview")]),
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.contentPreview")) +
              "\n            "
          ),
        ]),
        _vm._v(" "),
        !_vm.editMode
          ? _c("div", { staticClass: "tpl-markdown markdown" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.knowledgeBase.article.content) +
                  "\n            "
              ),
            ])
          : _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.knowledgeBase.article.content,
                  expression: "knowledgeBase.article.content",
                },
              ],
              staticClass: "answer-input",
              attrs: { type: "text" },
              domProps: { value: _vm.knowledgeBase.article.content },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.knowledgeBase.article,
                    "content",
                    $event.target.value
                  )
                },
              },
            }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }